import React from 'react'
import { motion } from 'framer-motion'
import { Clock, MapPin, User, ChevronRight } from 'lucide-react'
import { isSessionUpcoming, fmtTimeRange } from './corporate-helpers'

export const SessionCard = ({ session, onSelect }) => {
    const upcoming = isSessionUpcoming(session.sessionDate)

    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onSelect(session)}
            className={`relative overflow-hidden rounded-xl border cursor-pointer transition-all duration-200 ${
                upcoming
                    ? 'border-indigo-100 bg-white hover:border-indigo-200 hover:shadow-md'
                    : 'border-gray-100 bg-gray-50 hover:border-gray-200'
            }`}
        >
            {upcoming && (
                <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-linear-to-b from-indigo-500 to-violet-500" />
            )}
            <div className="flex items-center gap-3 p-3.5 pl-4">
                {/* Date badge */}
                <div className={`shrink-0 w-12 h-12 rounded-xl flex flex-col items-center justify-center ${
                    upcoming ? 'bg-indigo-50' : 'bg-gray-100'
                }`}>
                    <span className={`text-[10px] font-bold uppercase ${upcoming ? 'text-indigo-500' : 'text-gray-400'}`}>
                        {new Date(session.sessionDate).toLocaleDateString('en', { month: 'short' })}
                    </span>
                    <span className={`text-base font-bold leading-tight ${upcoming ? 'text-indigo-700' : 'text-gray-500'}`}>
                        {new Date(session.sessionDate).getDate()}
                    </span>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-gray-900 truncate">{session.sessionTitle || 'Session'}</p>
                    <div className="flex items-center gap-2 mt-0.5">
                        <Clock size={11} className="text-gray-400" />
                        <span className="text-xs text-gray-500">
                            {fmtTimeRange(session.startTime, session.endTime)}
                        </span>
                    </div>
                    {session.location && (
                        <div className="flex items-center gap-2 mt-0.5">
                            <MapPin size={11} className="text-gray-400" />
                            <span className="text-xs text-gray-500 truncate">{session.location}</span>
                        </div>
                    )}
                </div>

                {/* Trainer avatar */}
                {session.trainer?.profilePicture ? (
                    <img
                        src={session.trainer.profilePicture}
                        alt=""
                        className="w-8 h-8 rounded-full object-cover border border-white shadow-sm shrink-0"
                    />
                ) : session.trainer ? (
                    <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center shrink-0">
                        <User size={14} className="text-indigo-500" />
                    </div>
                ) : null}

                <ChevronRight size={16} className="text-gray-300 shrink-0" />
            </div>
        </motion.div>
    )
}
